<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          <i class="fa fa-wrench mr-5"></i>
          {{ 'marketplace_settings' | translate }}
        </h3>
      </div>
    </div>
    <div v-for="config, index in this.configs" class="box box-solid collapsed-box">
      <div class="box-header no-border">
        <h3 class="box-title">{{ index | translate }}</h3>
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
      <div class="box-body" style="display: none;">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ 'merchant_country' | translate }}</th>
              <th>{{ 'customer_country' | translate}}</th>
              <th>{{ 'carrier' | translate }}</th>
              <th>{{ 'direction' | translate }}</th>
              <th>{{ 'carrier_service_method' | translate }}</th>
              <th>{{ 'is_international' | translate }}</th>
              <th>{{ 'dpd_allowed' | translate }}</th>
              <th>{{ 'overridable' | translate }}</th>
              <th>{{ 'actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="carrier, carrierId in config">
              <td>{{ carrier.merchant_country }}</td>
              <td>{{ carrier.customer_country }}</td>
              <td>{{ carrier.carrier }}</td>
              <td>{{ carrier.direction }}</td>
              <td>{{ carrier.carrier_service_method }}</td>
              <td>{{ carrier.is_international }}</td>
              <td>{{ carrier.dpd_allowed }}</td>
              <td>{{ carrier.overridable }}</td>
              <td>
                <button
                  class="btn btn-flat btn-info mb-10 mt-10"
                  data-toggle="modal"
                  data-target="#countryCarrierConfigModal"
                  @click="openSalesChannelConfigModal(index, carrierId)">
                  <i class="fa fa-wrench mr-5"></i>
                  {{'edit'|translate}}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="box-footer">
        <button
          class="btn btn-flat btn-info mb-10 mt-10 pull-right"
          data-toggle="modal"
          data-target="#countryCarrierConfigModal"
          @click="openNewWindowModal()"
        >
          <i class="fa fa-wrench mr-5"></i>
          {{'new'|translate}}
        </button>
      </div>
    </div>
    <CountryCarrierConfigModal id="countryCarrierConfigModal" :isNew="openNewWindow" :modalSalesChannelConfig="modalSalesChannelConfig"></CountryCarrierConfigModal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      configs: {},
      modalSalesChannelConfig: {},
      openNewWindow: false
    }
  },
  methods: {
    openSalesChannelConfigModal(channel, configId) {
      this.modalSalesChannelConfig = this.configs[channel][configId]
      this.openNewWindow = false
    },
    openNewWindowModal() {
      this.modalSalesChannelConfig = {}
      this.openNewWindow = true
    },
  },
  computed: {},
  mounted() {
    API.get('countryCarriers/')
      .then(res => {
        this.configs = res.data
      })
  },
}
</script>

<style>
.overlay {
  z-index: 50;
  background: rgba(33, 34, 40, .75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
}

.overlay > .fa {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1rem;
  margin-top: -1rem;
  color: currentColor;
  font-size: 2rem;
  opacity: 0.65;
}

.min-width-45 {
  min-width: 45%;
}
</style>
<style scoped>
.loading-gif {
  display: block;
  width: 5%;
  top: 42%;
  left: 50%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CountryCarrierSettings.vue